import React from "react";
import { motion } from "framer-motion";
import { MapPin, ExternalLink } from "lucide-react";
import { SITE } from "@/lib/site";

const Location = () => {
  return (
    <section id="localizacao" data-testid="location-section" className="py-24 md:py-32 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="grid lg:grid-cols-12 gap-10 items-end mb-12"
        >
          <div className="lg:col-span-7">
            <p className="overline mb-5">
              <span className="gold-rule mr-3 align-middle" />Localização
            </p>
            <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight">
              Atendimento presencial <br />
              em <span className="italic">Manaus</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#475569] text-base lg:text-lg leading-relaxed mb-5">
              {SITE.address}. Atendimento mediante agendamento prévio.
            </p>
            <a
              href={SITE.mapsShortUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="maps-cta"
              className="inline-flex items-center gap-2 text-sm text-[#0A1128] border-b border-[#C5A059] pb-1 hover:text-[#C5A059] transition-colors"
            >
              <MapPin size={16} strokeWidth={1.5} className="text-[#C5A059]" />
              <span>Ver no Google Maps</span>
              <ExternalLink size={14} strokeWidth={1.5} />
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="relative border border-[#E2E8F0] bg-white p-2 md:p-3"
        >
          <div className="aspect-[16/8] md:aspect-[16/6] w-full overflow-hidden">
            <iframe
              title="Glotaris — Localização no Google Maps"
              src={SITE.mapsEmbedUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              data-testid="maps-iframe"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Location;
